<template>
  <div class="queItem">
    <ul class="news-content"
        slot="item">
      <li v-for="(item, index) in newsList"
          :key="index"
          @click="goDetail(item)">
        <div class="item_info">
          <img class="avatar"
               :src="item.avatar" />
          <div class="title">
            <span class="name">{{item.nickname}}</span>
            <span class="desc">{{item.created_at}}</span>
          </div>
          <router-link class="arrow" :to="{name:'Tip'}" v-if="$store.state.app=='ios'">
            <img src="@/assets/images/arrow.png" />
          </router-link>
        </div>
        <div class="item_content">
          <p class="que_title" v-html="item.title"></p>
          <div class="ans_conten"
               v-if="eps_lines"
               ref="desc"
               id="desc"
               :title="item.content">
            <span v-html="item.content.length>118&&!showTotal?item.content.substring(0,115)+'...':item.content"></span>
            <span class="unfold"
                 @click="showTotalIntro"
                 v-if="item.content.length>118">
              <p>{{exchangeButton ? '查看全部' : '收起'}}</p>
            </span>
          </div>
          <div class="ans_conten lines"
               v-else
               ref="desc" v-html="item.content">
          </div>
        </div>
        <slot name="images"></slot>
        <slot class="top_right_icon"
              name="right-icon"></slot>
        <slot name="other_content"></slot>
      </li>
    </ul>
  </div>
</template>

<script>
import Empty from "@/components/Empty";
import List from "@/components/List";
export default {
  name: "queItem",
  components: {
    Empty,
    List
  },
  props: {
    newsList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    eps_lines: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data () {
    return {
      title: {
        name: "问答列表"
      },
      classify: [], // 资讯类别
      // newsList: [], // 资讯列表
      params: {
        classify_id: ""
      },
      showList: false, // 是否展示列表，在请求到分类之前不展示
      // 是否展示所有文本内容
      showTotal: false,
      // 显示展开还是收起
      exchangeButton: true,
      // 是否显示展开收起按钮
      showExchangeButton: false,
    };
  },
  created () {
    this.classify = [
      { id: 0, name: "回答", parent_id: 0 },
      { id: 0, name: "课程回答", parent_id: 0 },
      { id: 0, name: "题目回答", parent_id: 0 },
      { id: 0, name: "我的追问", parent_id: 0 },
    ];
    this.showList = true;
  },
  mounted () {
  },
  methods: {
    showTotalIntro () {
      this.showTotal = !this.showTotal;
      this.exchangeButton = !this.exchangeButton;
    },
    goDetail (item) {
      this.$emit('goDetail', item)
    }
  }
};
</script>

<style lang="scss" scoped>
.queItem {
  // @extend %default-bg;
  background-color: #fff;
  .news-content {
    padding: 10px 30px;
    li {
      padding: 20px;
      background: #fff;
      border-bottom: 1px solid #f6f6f6;
      .item_content {
        margin-top: 10px;
        margin-left: 66px;
        .que_title {
          font-size: 26px;
          color: #333333;
          line-height: 32px;
        }
        .ans_conten {
          width: 100%;
          position: relative;
          display: inline-block;
          margin-top: 10px;
          color: #7c7c7c;
          font-size: 24px;
          line-height: 33px;
          &.lines {
            @include lines-eps(5);
          }
          .unfold {
            float: right;
            margin-top: 7px;
            text-align: right;
            height: 21px;
            p {
              margin: 0;
              line-height: 21px;
              color: $theme_color;
            }
          }
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
      .avatar {
        display: block;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        flex: none;
        margin-right: 16px;
        float: left;
      }
      .img_items {
        margin: 20px 0;
        display: flex;
        justify-content: space-between;
        .img_item {
          width: 160px;
          height: 160px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .title {
        float: left;
        padding-top: 4px;
      }
      .arrow{
        padding:12px 30px;
        img{
          width: 24px;
          float: right;
        }
        float: right;
      }
      & > div {
        overflow: hidden;
        .name {
          @include eps;
          font-size: 28px;
          font-weight: 500;
          color: #333;
          display: block;
        }
        .desc {
          @include eps;
          margin-top: 10px;
          font-size: 22px;
          display: block;
          color: #999;
        }
      }
    }
    li:nth-last-child(1) {
      border-bottom: none;
    }
  }
}
</style>
